import React, { useEffect } from 'react'
import '../css/styles.css';
import Customer from '../img/customer_support.png';
import Innovation from '../img/innovation.png';
import ProductQuality from '../img/product_quality.png';
import Employee from '../img/employee.png';
import Growth from '../img/growth.png';
import {Link} from 'react-router-dom';


export default function Aboutsus() {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []); // Empty dependency array means this runs once when the component mounts
  return (
    <>
      <section id="about-hero" className="hero d-flex align-items-center">
        <div className="container" data-aos-delay="100">
          <div className="row">
            <div id="about-top" className="col-12 hero-right">
            </div>

            <div id="about-bottom" className="col-12 hero-bottom">
              <h1>ABOUT US</h1>
              <h2 id="about-hero">We are the most reliable source for your rapid prototyping,
                On-demand manufacturing and mass production requirements</h2>
              <div className="d-flex align-items-center justify-content-center">
                <span id="btn-getquote" className="btn-get-started scrollto"><Link to="/contact">Get Quote</Link></span>
              </div>
            </div>

          </div>
        </div>
      </section>
      
      <section id="managing_director" className="services">
        <div className="container aos-init aos-animate" data-aos="fade-up">

          <div className="col-12 aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
            <div id="director" className="d-flex align-items-center justify-content-center">
              <div className="sec-title">
                <h3>Overview</h3>
              </div>
            </div>
            <div className="text-contain">
              <p className="font-regular" style={{textAlign : "center"}}>
                Shree Siddhi Vinayak Engineering is a premier metal laser cutting service provider.Specializing in precision and high-quality sheet metal processing.
                We cater to a wide range of industries with our state-of-the-art Laser cutting technology. Our services include all type of metal cutting Mild sheet(MS), Stainless Sheet(SS), Aluminium, 
                Titanium, Brass & Copper, ensuring precise and efficient solutions for all your metal fabrication needs.
                <br/>
                We offer custom solutions tailored to meet the diverse needs of our clients. Whether for large-scale industrial applications or custom projects.Our firm is committed to 
                delivering top-notch quality and timely service. Out team of skilled professionals combine expertise and advanced technology to provide cost-effective and reliable service.

              </p>
            </div>
          </div>
        </div>
      </section>

    <section id="vision" className="services">
      <div className="container" data-aos="fade-up">

        <div className="section-title">
          <h3>Why Us ?</h3>
        </div>

        <div className="row">
          <div className="vis-box col-lg-2 col-md-4 col-sm-6 col-xs-12 d-flex mt-4" data-aos="zoom-in" data-aos-delay="50">
            <div id="customer" className="box-img">
              <div id="customer-box" className="img-fluid">
                <img src={Customer} alt="" width={"70px"} height={"70px"}/>
              </div>
              <h6>Customer delight is paramount</h6>
            </div>
          </div>

          <div className="vis-box col-lg-2 col-md-4 col-sm-6 col-xs-12 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="50">
            <div id="tech" className="box-img">
              <div id="tech-box" className="img-fluid">
                <img src={Innovation} alt="" width={"70px"} height={"70px"}/>
              </div>
              <h6>Focus on Tech & Innovation</h6>
            </div>
          </div>

          <div className="vis-box col-lg-2 col-md-4 col-sm-6 col-xs-12 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="50">
            <div id="employees" className="box-img">
              <div id="employees-box" className="img-fluid">
                <img src={ProductQuality} alt="" width={"70px"} height={"70px"}/>
              </div>
              <h6>Product Quality and EHS foundation</h6>
            </div>
          </div>

          <div className="vis-box col-lg-2 col-md-4 col-sm-6 col-xs-12 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="50">
            <div id="growth" className="box-img">
              <div id="growth-box" className="img-fluid">
                <img src={Employee} alt="" width={"70px"} height={"70px"}/>
              </div>
              <h6>Employee are Prime movers</h6>
            </div>
          </div>

          <div className="vis-box col-lg-2 col-md-4 col-sm-6 col-xs-12 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="50">
            <div id="quality" className="box-img">
              <div id="quality-box" className="img-fluid">
                <img src={Growth} alt="" width={"70px"} height={"70px"}/>
              </div>
              <h6>Sustainable & Profitable Growth</h6>
            </div>
          </div>

        </div>

      </div>
    </section>

    <section id="mission">
      <div className="container aos-init aos-animate" data-aos="fade-in">

        <div className="section-title">
          <h3>Mission</h3>
        </div>

        <div className="row">
          <div className="text-contain col-12 align-items-center justify-content-center">
            <div id="point_1" className="points">
              <i className="bx bx-chevron-right"></i>
              <h5>To provide exceptional metal laser cutting solutions with precision,efficiency, and reliability.</h5>
            </div>
            <div id="point_2" className="points">
              <i className="bx bx-chevron-right"></i>
              <h5>We strive to exceed client expectations by leveraging innovative technology, skilled craftsmanship, and a customer-centric approach.</h5>
            </div>
            <div id="point_3" className="points">
              <i className="bx bx-chevron-right"></i>
              <h5>Our goal is to be the preferred partner for industries requiring cutting-edge metal fabrication services.</h5>
            </div>
          </div>
        </div>

      </div>
    </section>

    </>
  )
}
